export function getDeprecationSuggestion(scope) {
    const suggestions = {
        all: 'getAllData()',
        filtered: 'getFilteredData()',
        visible: 'getVisibleData()',
        page: 'getPageData()',
        'current-page': 'getCurrentPageData()',
        selected: 'getSelectedData()'
    };
    return suggestions[scope] || 'a dedicated getData* method';
}

export function getDataByScope(adapter, scope) {
    switch (scope) {
        case 'all':
            return adapter.getAllData();
        case 'page':
        case 'current-page':
            return adapter.getPageData();
        case 'selected':
            return adapter.getSelectedData();
        case 'visible':
        case 'filtered':
        default:
            return adapter.getFilteredData();
    }
}

export function getSelectedData(adapter) {
    if (adapter._useNativeSelect) {
        return adapter._instance.rows({ selected: true }).data().toArray();
    }
    return Array.from(adapter._selectedRows)
        .map((idx) => adapter._instance.row(idx).data())
        .filter(Boolean);
}
